var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { DatePipe } from '@angular/common';
import { UploadService } from './../d-i/upload.service';
import { NgSelectComponent } from '@ng-select/ng-select';
var ChapterAnnouncementsComponent = /** @class */ (function () {
    function ChapterAnnouncementsComponent(userService, adminService, spinner, bpgCommonService, bpgEventsService, router, environment, datePipe, uploadService) {
        this.userService = userService;
        this.adminService = adminService;
        this.spinner = spinner;
        this.bpgCommonService = bpgCommonService;
        this.bpgEventsService = bpgEventsService;
        this.router = router;
        this.environment = environment;
        this.datePipe = datePipe;
        this.uploadService = uploadService;
        this.LandingPaginationDTO = new LandingPaginationDTO();
        this.user = null;
        this.role = null;
        this.roleName = null;
        this.userFirstName = null;
        this.currentPage = 0;
        this.currentNumberOfElements = 10;
        this.totalPages = 0;
        this.limit = 10;
        this.currentShowingElements = 10;
        this.eventPicture = true;
        this.uploadFileName = null;
        this.uploadFileExtension = false;
        this.uploadedFile = null;
        this.action = "";
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.selectedFile = null;
        this.selectedFileName = "Upload < 500MB";
        this.announcementFile = "";
        this.fileList = [];
        this.selectedSiteIdSearch = 0;
        this.selectedBpgIdSearch = 0;
        this.page = 0;
        this.isFileUploded = false;
        this.announcementItemsList = null;
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.uploadFlag = "chapterAnnouncements";
        this.errorMsgUploadSave = false;
        this.announceLinkValid = false;
        this.typeList = [{ type: 'Select All' }, { type: 'Document' }, { type: 'Image' }, { type: 'Video' }];
        this.firstEdit = false;
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
    }
    ChapterAnnouncementsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.editandSavebtn = false;
        this.savebtn = true;
        if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
            if (localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        if (localStorage.getItem('logOutFlag') == "true") {
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/log-out']);
            localStorage.setItem("logOutFlag", "true");
        }
        this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
        localStorage.removeItem('searchedEventsCaledarItems');
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.adminId = localStorage.getItem('adminId');
        // if (this.loginDetails == null) {
        //   this.router.navigate(['/login']);
        // }
        this.spinner.show();
        sessionStorage.removeItem("MembershipData");
        this.selectedSiteId = localStorage.getItem('userSiteId');
        this.leadAdminId = localStorage.getItem('leadAdminId');
        if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
            localStorage.setItem('adminId', '2');
        }
        if (localStorage.getItem('isbpgAdmin') == 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isbpgLeadAdmin') === 'true') {
            this.isbpgLeadAdmin = true;
        }
        this.loginUserAdminId = localStorage.getItem('adminId');
        this.userAndRoleIdDTO = {
            userId: this.loginDataDetails['userId'],
            roleId: localStorage.getItem('adminId')
        };
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.createdBy = this.loginData.userId;
        this.modifiedBy = this.loginData.userId;
        this.bpgCommonService.getSessionToken();
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
            this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(function (data) {
                _this.chapterList = data;
                if (_this.chapterList.length > 1) {
                    _this.chapterList.unshift({ chapterId: 0, siteName: 'Select All', bpgName: '' });
                }
                for (var i = 0; i < _this.chapterList.length; i++) {
                    if (i == 0) {
                        _this.chapterIds = _this.chapterList[i].chapterId;
                    }
                    else {
                        _this.chapterIds = _this.chapterIds + "," + _this.chapterList[i].chapterId;
                    }
                }
                _this.siteData = {
                    "filter": {
                        chapterId: _this.chapterIds
                    },
                    "moduleId": 0,
                    "page": 0,
                    "presentRole": "",
                    "searchTerm": "",
                    "size": 0,
                    "sortDirection": "ASC",
                    "sortProperty": "",
                    "uid": ""
                };
                _this.bpgCommonService.getSiteList(_this.siteData).subscribe(function (data) {
                    _this.siteList = data;
                    _this.siteListSearch = data;
                    _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
                    _this.siteListSearch = _this.siteListSearch.filter(function (site) { return site.locationCode !== 'DFLT'; });
                    _this.siteListSearch.unshift({ siteId: 0, siteName: 'Select All', bpgName: '' });
                    for (var i = 0; i < _this.siteList.length; i++) {
                        if (i == 0) {
                            _this.allSiteIds = _this.siteList[i].siteId;
                        }
                        else {
                            _this.allSiteIds = _this.allSiteIds + _this.siteList[i].siteId + ",";
                        }
                    }
                    for (var i = 0; i < _this.siteListSearch.length; i++) {
                        if (i == 0) {
                            _this.allSiteIds = _this.siteListSearch[i].siteId;
                        }
                        else {
                            _this.allSiteIds = _this.allSiteIds + _this.siteListSearch[i].siteId + ",";
                        }
                    }
                    _this.getBpgList();
                    _this.getBpgListSearch();
                });
            });
            this.getSiteName();
        }
        else if (this.loginUserAdminId == "1") {
            this.getSiteName();
            this.getSiteList();
            this.getBpgList();
            this.getBpgListSearch();
            this.getChapterAnnouncementList();
        }
        this.loginUserId = this.loginData.userId;
        setTimeout(function () {
            this.spinner.hide();
        }.bind(this), 500);
    };
    /** get site name in the dropdown for lead admin
      * @class ChapterAnnouncementComponent
      * @method getSiteName
      */
    ChapterAnnouncementsComponent.prototype.getSiteName = function () {
        this.selectedSite = this.loginData.site.siteName;
    };
    /** get site list in the dropdown
      * @class ChapterAnnouncementComponent
      * @method getSiteList
      */
    ChapterAnnouncementsComponent.prototype.getSiteList = function () {
        var _this = this;
        this.siteData = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.bpgCommonService.getSiteList(this.siteData).subscribe(function (data) {
            _this.siteList = data;
            _this.siteListSearch = data;
            _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteListSearch = _this.siteListSearch.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteListSearch.unshift({ siteId: 0, siteName: 'Select All', bpgName: '' });
            if (_this.siteList != null || _this.siteListSearch != null) {
                for (var i = 0; i < _this.siteList.length; i++) {
                    if (_this.siteList[i].siteId == _this.selectedSiteId) {
                        _this.selectedSite = _this.siteList[i].siteName;
                    }
                }
                for (var i = 0; i < _this.siteListSearch.length; i++) {
                    if (_this.siteListSearch[i].siteId == _this.selectedSiteId) {
                        _this.selectedSite = _this.siteListSearch[i].siteName;
                    }
                }
                for (var i_1 = 0; i_1 < _this.siteList.length; i_1++) {
                    if (i_1 == 0) {
                        _this.allSiteIds = _this.siteList[i_1].siteId;
                    }
                    else {
                        _this.allSiteIds = _this.allSiteIds + _this.siteList[i_1].siteId + ",";
                    }
                }
                for (var i_2 = 0; i_2 < _this.siteListSearch.length; i_2++) {
                    if (i_2 == 0) {
                        _this.allSiteIds = _this.siteListSearch[i_2].siteId;
                    }
                    else {
                        _this.allSiteIds = _this.allSiteIds + _this.siteListSearch[i_2].siteId + ",";
                    }
                }
            }
        });
    };
    /** get chapter announcement list
     * @class ChapterAnnouncementComponent
     * @method getChapterAnnouncementList
     */
    ChapterAnnouncementsComponent.prototype.getChapterAnnouncementList = function () {
        var _this = this;
        this.spinner.show();
        if (this.selectedSiteIdSearch == 0) {
            this.selectedSiteIdSearch = this.allSiteIds;
        }
        if (this.selectedBpgIdSearch == 0) {
            this.selectedBpgIdSearch = this.allBpgIds;
        }
        this.landingData = {
            "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedBpgIdSearch },
            "moduleId": 0,
            "page": this.page,
            "presentRole": "string",
            "searchTerm": "string",
            "size": this.limit,
            "sortDirection": "DESC",
            "sortProperty": "createdDateTime",
            "uid": "string"
        };
        this.userService.getChapterAnnouncementList(this.landingData).subscribe(function (data) {
            _this.spinner.hide();
            if (data != null && data != undefined) {
                _this.announcementItemsList = data.content;
                _this.numberOfElements = data.totalElements;
                if (_this.announcementItemsList.length == 0) {
                    _this.noDataFound = true;
                    _this.tableShow = false;
                }
                else {
                    _this.noDataFound = false;
                    _this.tableShow = true;
                }
            }
            else {
                _this.noDataFound = true;
                _this.tableShow = false;
            }
        });
    };
    /** get bpg list in the dropdown
      * @class ChapterAnnouncementComponent
      * @method getBpgList
      */
    ChapterAnnouncementsComponent.prototype.getBpgList = function () {
        var _this = this;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteId,
                    "adminId": this.loginUserAdminId,
                    "userId": this.createdBy
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgList = data;
            if (_this.bpgList.length != 0) {
            }
            else {
                _this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
            }
            if (_this.bpgList != null) {
                for (var i = 0; i < _this.bpgList.length; i++) {
                    // this.allBpgIds.push(this.bpgList[i].bpgId);
                    if (_this.bpgList[i].bpgId == _this.selectedBpgId) {
                        _this.selectedBpg = _this.bpgList[i].bpgName;
                    }
                }
                for (var i_3 = 0; i_3 < _this.bpgList.length; i_3++) {
                    if (i_3 == 0) {
                        _this.allBpgIds = _this.bpgList[i_3].bpgId;
                    }
                    else {
                        _this.allBpgIds = _this.allBpgIds + _this.bpgList[i_3].bpgId + ",";
                    }
                }
            }
        });
    };
    ChapterAnnouncementsComponent.prototype.getBpgListSearch = function () {
        var _this = this;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteIdSearch,
                    "adminId": this.loginUserAdminId,
                    "userId": this.createdBy
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "",
                "searchTerm": "",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "",
                "uid": ""
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgListSearch = data;
            if (_this.bpgListSearch != null) {
                _this.bpgListSearch.unshift({ bpgId: 0, bpgName: 'Select All' });
                for (var i = 0; i < _this.bpgListSearch.length; i++) {
                    // this.allBpgIds.push(this.bpgList[i].bpgId);
                    if (_this.bpgListSearch[i].bpgId == _this.selectedBpgId) {
                        _this.selectedBpg = _this.bpgListSearch[i].bpgName;
                    }
                }
                for (var i_4 = 0; i_4 < _this.bpgListSearch.length; i_4++) {
                    if (i_4 == 0) {
                        _this.allBpgIds = _this.bpgListSearch[i_4].bpgId;
                    }
                    else {
                        _this.allBpgIds = _this.allBpgIds + _this.bpgListSearch[i_4].bpgId + ",";
                    }
                }
                if (_this.loginUserAdminId === "2" || _this.loginUserAdminId === "3" || _this.isbpgAdmin || _this.isbpgLeadAdmin) {
                    _this.getChapterAnnouncementList();
                }
            }
        });
    };
    /** get chapter id
    * @class ChapterAnnouncementComponent
    * @method getChapterIds
    */
    ChapterAnnouncementsComponent.prototype.getChapterIds = function () {
        var _this = this;
        this.landingData = {
            "filter": {
                "bpgId": this.selectedBpgId,
                "siteId": this.selectedSiteId
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.userService.getChapterByBpg(this.landingData).subscribe(function (data) {
            if (data != null) {
                for (var i = 0; i < data.length; i++) {
                    _this.chapterId = data[i];
                }
            }
        });
    };
    /** For site change from site list
       * @class ChapterAnnouncementComponent
       * @method siteChange
       * @returns Promise
       */
    ChapterAnnouncementsComponent.prototype.siteChange = function (event) {
        this.selectedBpgId = null;
        this.selectedBpg = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedSiteId = event.siteId;
        this.bpgList = [];
        this.getBpgList();
    };
    /** For bpg change from bpg list
      * @class ChapterAnnouncementComponent
      * @method bpgChange
      * @returns Promise
      */
    ChapterAnnouncementsComponent.prototype.bpgChange = function (event) {
        this.selectedBpgId = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedBpgId = event.bpgId;
        this.getChapterIds();
    };
    ChapterAnnouncementsComponent.prototype.onFileSelected = function (event) {
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        if (event.target.files.length > 0) {
            this.announcementFile = event.target.files[0].name;
            this.fileSize = event.target.files[0].size;
            var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "csv"];
            this.fileExtension = this.announcementFile.split('.').pop();
            if (this.isInArray(allowedExtensions, this.fileExtension)) {
                if (this.fileSize > 524288000) {
                    this.fileSizeExtensionError = true;
                }
                else {
                    this.fileExtensionError = false;
                    this.fileSizeExtensionError = false;
                    this.selectedFile = event.target.files[0];
                    this.selectedFileName = this.selectedFile.name;
                    this.isFileUploded = true;
                }
            }
            else {
                this.fileExtensionError = true;
                this.selectedFileName = "Upload < 500MB";
            }
        }
    };
    /** checks if word exists in array
     * @class ChapterAnnouncementComponent
     * @method isInArray
     */
    ChapterAnnouncementsComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    /** For adding 365 days to current day
  * @class ChapterAnnouncementComponent
  * @method addDays
  * @params Date, number
  */
    ChapterAnnouncementsComponent.prototype.addDays = function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    };
    /** to submit resource
     * @class ChapterAnnouncementComponent
     * @method onChapterAnnouncementSubmit
     */
    ChapterAnnouncementsComponent.prototype.onChapterAnnouncementSubmit = function () {
        this.alertSuccess = false;
        this.alertFailure = false;
        this.timeOutError = false;
        this.alertUpdateSuccess = false;
        this.method = "addAnnouncement";
        this.param = '';
        if (this.editandSavebtn) {
            this.msg1 = " Are you sure you want to update ? ";
        }
        else {
            this.msg1 = " Are you sure you want to save ? ";
        }
    };
    /** to add new admin
      * @class ChapterAnnouncementComponent
      * @method addAnnouncement
      */
    ChapterAnnouncementsComponent.prototype.addAnnouncement = function () {
        var _this = this;
        //removing special characters from filename
        var str = this.selectedFileName;
        var arr = str.split(".");
        var lastVal = arr.pop();
        var firstVal = arr.join(".");
        this.selectedFileName = firstVal.replace(/[&\/\\#,+()$~%.'"_:*?<>{}]/g, '') + "." + lastVal;
        this.timeOutError = false;
        var announcementData = null;
        this.modifiedDateTime = new Date();
        if (this.selectedFile == null || this.selectedFile == undefined) {
            this.selectedFileName = '';
        }
        if (this.editandSavebtn != true) {
            announcementData = {
                "createdBy": this.createdBy,
                "createdDateTime": this.createdDateTime,
                "isActive": true,
                "modifiedBy": this.modifiedBy,
                "modifiedDateTime": this.modifiedDateTime,
                "announcementFile": this.selectedFileName,
                "bpgId": this.selectedBpgId,
                "siteId": this.selectedSiteId,
                "announcementTitle": this.announcementTitle,
                "announcementDescription": this.announcementDescription,
                "externalLinks": this.externalLinks,
                "chaptersAnnouncementId": 0
            };
        }
        else {
            announcementData = {
                "chaptersAnnouncementId": this.chaptersAnnouncementId,
                "createdBy": this.createdBy,
                "createdDateTime": this.createdDateTime,
                "isActive": true,
                "modifiedBy": this.modifiedBy,
                "modifiedDateTime": this.modifiedDateTime,
                "announcementFile": this.selectedFileName,
                "bpgId": this.selectedBpgId,
                "siteId": this.selectedSiteId,
                "announcementTitle": this.announcementTitle,
                "announcementDescription": this.announcementDescription,
                "externalLinks": this.externalLinks
            };
        }
        var uploadData = {
            'category': 'uploadDocument',
        };
        this.spinner.show();
        this.userService.addchapterAnnouncement(announcementData).subscribe(function (data) {
            _this.announcementList = data.body;
            _this.spinner.hide();
            console.log(_this.announcementList);
            if (_this.editandSavebtn == true) {
                _this.spinner.hide();
                _this.alertUpdateSuccess = true;
                _this.deleteSuccess = false;
                _this.errorMsgUploadSave = false;
                _this.alertSuccess = false;
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 300);
                _this.getChapterAnnouncementList();
            }
            if (data == null) {
            }
            if (data.message != undefined) {
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 300);
            }
            else if (data != undefined) {
                if (_this.selectedFile == null) {
                    if (_this.editandSavebtn != true) {
                        _this.alertSuccess = true;
                    }
                    else {
                        _this.alertUpdateSuccess = true;
                    }
                    _this.getChapterAnnouncementList();
                }
                if (_this.selectedFile != null) {
                    _this.spinner.show();
                    _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.awsUrls = data;
                                    return [4 /*yield*/, this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.announcementList.chaptersAnnouncementId, this.uploadFlag)];
                                case 1:
                                    _a.sent();
                                    console.log("errorUpl" + localStorage.getItem('uploadError'));
                                    if (localStorage.getItem('uploadError') == 'Error') {
                                        this.userService.deleteChapterAnnouncement(this.announcementList.chaptersAnnouncementId).subscribe(function (data) {
                                            _this.spinner.hide();
                                            _this.errorMsgUploadSave = true;
                                            _this.alertSuccess = false;
                                            _this.deleteSuccess = false;
                                            localStorage.removeItem('uploadError');
                                        });
                                    }
                                    else {
                                        if (this.editandSavebtn != true) {
                                            this.alertSuccess = true;
                                        }
                                        this.deleteSuccess = false;
                                        this.errorMsgUploadSave = false;
                                        this.getChapterAnnouncementList();
                                    }
                                    setTimeout(function () {
                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                    }, 200);
                                    this.spinner.hide();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) {
                        _this.spinner.hide();
                        if (err.value.statusText == ConstantValues.unknownError) {
                            _this.timeOutError = true;
                        }
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                    });
                }
            }
        });
    };
    /** For filtering data by current page
     * @class chapterComponent
     * @method pageChanged
     * @params event
     */
    ChapterAnnouncementsComponent.prototype.pageChanged = function (event) {
        this.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElements = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElements = this.numberOfElements;
        }
        this.getChapterAnnouncementList();
    };
    /** Confirm on reset
      * @class ChapterAnnouncementComponent
      * @method resetAnnouncement
      */
    ChapterAnnouncementsComponent.prototype.resetAnnouncement = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.myInputVariable.nativeElement.value = "";
        this.selectedBpg = null;
        this.selectedBpgId = null;
        this.selectedBpgIdSearch = null;
        this.selectedSiteIdSearch = null;
        this.searchKey = null;
        this.LandingPaginationDTO.searchTerm = null;
        this.selectedFileName = "Upload < 500MB";
        this.selectedSiteId = localStorage.getItem('userSiteId');
        this.deleteSuccess = false;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.alertSuccess = false;
        this.selectedFile = null;
        this.isFileUploded = false;
        this.selectedBpgSearch = null;
        this.selectedSiteSearch = null;
        this.errorMsgUploadSave = false;
        this.announcementTitle = "";
        this.announcementDescription = "";
        this.externalLinks = "";
        this.announceLinkValid = false;
        this.selectedSite = this.loginData.site.siteName;
        this.eventPicture = true;
        this.editandSavebtn = false;
        this.savebtn = true;
        this.firstEdit = false;
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
            this.selectedSiteIdSearch = 0;
            this.selectedBpgIdSearch = 0;
            this.getBpgListSearch();
        }
        this.getChapterAnnouncementList();
        this.getBpgList();
    };
    /** For site change from site list
     * @class ChapterAnnouncementComponent
     * @method siteChangeSearch
     * @returns Promise
     */
    ChapterAnnouncementsComponent.prototype.siteChangeSearch = function (event) {
        this.selectedSiteIdSearch = event.siteId;
        this.getBpgListSearch();
    };
    /** For bpg change from bpg list
      * @class ChapterAnnouncementComponent
      * @method bpgChangeSearch
      * @returns Promise
      */
    ChapterAnnouncementsComponent.prototype.bpgChangeSearch = function (event) {
        this.selectedBpgId = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedBpgIdSearch = event.bpgId;
        this.selectedBpgId = event.bpgId;
        this.getChapterIds();
    };
    /** confirmation to delete gallery
    * @class ChapterAnnouncementComponent
    * @method deleteAnnouncementConfirmation
    */
    ChapterAnnouncementsComponent.prototype.deleteAnnouncementConfirmation = function (id) {
        this.alertSuccess = false;
        this.alertFailure = false;
        this.timeOutError = false;
        this.alertUpdateSuccess = false;
        this.method = "deleteAnnouncement";
        this.param = id;
        this.msg1 = "  Are you sure you want to delete ? ";
    };
    /** to delete announcement
  * @class ChapterAnnouncementComponent
  * @method deleteAnnouncement
  */
    ChapterAnnouncementsComponent.prototype.deleteAnnouncement = function (id) {
        var _this = this;
        this.spinner.show();
        this.userService.deleteChapterAnnouncement(id).subscribe(function (data) {
            _this.spinner.hide();
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            _this.deleteSuccess = true;
            _this.alertSuccess = false;
            _this.errorMsgUploadSave = false;
            if (_this.announcementItemsList.length == 1 && _this.numberOfElements > 10) {
                _this.currentPage = 0;
                _this.page = 0;
                _this.currentShowingElements = 10;
            }
            _this.getChapterAnnouncementList();
        });
    };
    /** to reset resource
     * @class ChapterAnnouncementComponent
     * @method resetClick
     */
    ChapterAnnouncementsComponent.prototype.resetClick = function () {
        this.method = "resetAnnouncement";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    ChapterAnnouncementsComponent.prototype.getChapterAnnouncementListSearch = function () {
        this.page = 0;
        this.currentPage = 1;
        this.getChapterAnnouncementList();
    };
    /** link validation
  * @class DIComponent
  * @method onLinkType
  */
    ChapterAnnouncementsComponent.prototype.onLinkType = function (event, type) {
        var re = /^(http[s]?:\/\/){0,1}(www.\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        if (re.test(String(event.target.value).toLowerCase()) == false) {
            if (type == 'news') {
                if (event.target.value != "") {
                    this.announceLinkValid = true;
                }
                else {
                    this.announceLinkValid = false;
                }
            }
        }
        else {
            if (type == 'news') {
                this.announceLinkValid = false;
            }
        }
    };
    /** to add new admin
     * @class ChapterAnnouncementComponent
     * @method updateAnnouncement
     */
    ChapterAnnouncementsComponent.prototype.updateAnnouncement = function (data) {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertSuccess = false;
        this.alertFailure = false;
        this.editandSavebtn = true;
        this.savebtn = false;
        this.timeOutError = false;
        this.modifiedDateTime = new Date();
        this.modifiedBy = this.loginDataDetails['userId'];
        this.createdBy = this.loginDataDetails['userId'];
        this.createdDateTime = new Date();
        this.selectedFileName = data.announcementFile;
        this.announcementTitle = data.announcementTitle;
        this.selectedBpg = data.bpgName;
        this.selectedBpgId = data.bpgId;
        this.selectedSite = data.siteName;
        this.selectedSiteId = data.siteId;
        this.chaptersAnnouncementId = data.chaptersAnnouncementId;
        this.announcementDescription = data.announcementDescription;
        this.externalLinks = data.externalLinks;
        this.announceLinkValid = false;
        this.fileSizeExtensionError = false;
        this.fileExtensionError = false;
        if (this.selectedFileName == null || this.selectedFileName == undefined || this.selectedFileName == '')
            this.selectedFileName = "Upload < 500MB";
    };
    ChapterAnnouncementsComponent.prototype.editDocument = function (data, i) {
        if (this.firstEdit == false) {
            this.firstEdit = true;
            this.updateAnnouncement(data);
        }
        else {
            document.getElementById('edit' + i).setAttribute('data-toggle', 'modal');
            document.getElementById('edit' + i).setAttribute('data-target', '#myModal');
            this.method = "updateAnnouncement";
            this.param = data;
            this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
        }
    };
    return ChapterAnnouncementsComponent;
}());
export { ChapterAnnouncementsComponent };
